import { apiFetch } from "../../framework/api";
import type { HealthCheckResponse } from "./types/health";

// Quick health check - basic endpoint
export async function checkHealth(token: string): Promise<HealthCheckResponse> {
  return await apiFetch<HealthCheckResponse>('/session/health', { token, method: 'GET' });
}

// Full health check with all subsystems
export async function fetchHealthCheck(token: string): Promise<HealthCheckResponse> {
  return await apiFetch<HealthCheckResponse>('/session/health?subsystem=all', { token, method: 'GET' });
}

// Test sentinel error handling
export async function testSentinelError(token: string): Promise<HealthCheckResponse> {
  return await apiFetch<HealthCheckResponse>('/session/health?subsystem=error-sentinel', { token, method: 'GET' });
}

// Test error handling with abort
export async function testErrorAbort(token: string): Promise<HealthCheckResponse> {
  return await apiFetch<HealthCheckResponse>('/session/health?subsystem=error-abort', { token, method: 'GET' });
}

// Test error handling with runtime panic
export async function testErrorRuntime(token: string): Promise<HealthCheckResponse> {
  return await apiFetch<HealthCheckResponse>('/session/health?subsystem=error-runtime', { token, method: 'GET' });
}

// Test error handling with panic
export async function testErrorPanic(token: string): Promise<HealthCheckResponse> {
  return await apiFetch<HealthCheckResponse>('/session/health?subsystem=error-panic', { token, method: 'GET' });
}

// Test events subsystem
export async function testEvents(token: string): Promise<EventsTestResponse> {
  return await apiFetch<EventsTestResponse>('/session/health/events', { token, method: 'POST' });
}

// Test progress updates via WebSocket
export async function testProgress(token: string): Promise<ProgressTestResponse> {
  return await apiFetch<ProgressTestResponse>('/session/health/progress', { token, method: 'POST' });
}

export interface EventsTestResponse {
  Status: string;
  Message: string;
  UserId: number;
  EventType?: string;
}

export interface ProgressTestResponse {
  Status: string;
  Message: string;
  UserId: number;
}
